module.exports = __webpack_public_path__ + "img/healthy_public_ma.2321b6ed.png";